import styled from 'styled-components'

const StyledDiv = styled.div`
  width: 100%;
`

export default StyledDiv
